<template>
  <div class="f-col ctr recovery">
    <div class="f-col recovery-title">
      <span>Digite sua nova senha</span>
    </div>
    <form class="f-col ctr" @submit.prevent="handleSubmit">
      <div class="f-row ctr form-field">
        <label class="f-row ctr" for="password-field">
          <Icon icon="lock" />
          <span class="hidden">Senha</span>
        </label>
        <input
          class="f-row ctr"
          id="password-field"
          type="password"
          name="password"
          placeholder="Senha"
          required
          v-model="password"
        />
      </div>
      <div class="f-row ctr form-field">
        <label class="f-row ctr" for="password-confirm-field">
          <Icon icon="lock" />
          <span class="hidden">Confirme a senha</span>
        </label>
        <input
          class="f-row ctr"
          id="password-confirm-field"
          type="password"
          name="password-confirm"
          placeholder="Confirme a senha"
          required
          v-model="confirmPassword"
        />
      </div>
      <div class="f-row ctr form-submit">
        <button class="button-submit" type="submit" :disabled="loading">
          <template v-if="loading">
            <Icon
              icon="spinner"
              spin
              style="font-size: 22px; animation-duration: 1.2s"
            />
          </template>
          <template v-else>Trocar senha</template>
        </button>
      </div>
      <div class="f-col ctr form-notice">
        <strong>A senha precisa ter</strong>
        <ul>
          <li>No mínimo 8 caracteres</li>
          <li>Uma letra maiúscula</li>
          <li>Um símbolo</li>
          <li>Ao menos um número</li>
        </ul>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Recovery",
  props: {
    recovery: String,
  },
  data() {
    return {
      loading: false,
      password: "",
      confirmPassword: "",
      errorMessage: "",
    };
  },
  computed: {
    validatePassword() {
      const { password, confirmPassword } = this;

      const equals = password === confirmPassword;
      const eightChar = password.length >= 8;
      const oneUppercaseChar = /(?=.*[A-Z])/.test(password);
      const oneSymbolChar = /[-+_!@#$%^&*.,?]/.test(password);
      const oneNumber = /(?=.*\d)/.test(password);

      if (password.length === 0) return null;
      return (
        equals && eightChar && oneUppercaseChar && oneSymbolChar && oneNumber
      );
    },
  },
  methods: {
    backToLogin() {
      this.$store.commit("PRELUDE_UPDATE_CONTEXT", "login");
    },
    async handleSubmit() {
      try {
        if (this.loading) return;
        this.loading = true;

        if (this.validatePassword) {
          const response = await axios({
            url: `${process.env.VUE_APP_ADMIN_API_URL}/users.self.updatePassword`,
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.recovery}`,
            },
            data: {
              password: this.password,
              confirmPassword: this.confirmPassword,
            },
          });
          if (response?.status === 200) {
            this.$store.dispatch("ALERT", "Senha atualizada com sucesso");
            this.backToLogin();
          } else {
            this.$store.dispatch("ALERT", "Não foi possível atualizar a senha");
          }
        } else {
          this.$store.dispatch(
            "ALERT",
            "A nova senha não possui os requisitos básicos"
          );
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("ALERT", "Não foi possível alterar a senha");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.recovery {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

.recovery-title {
  font-size: 14px;
  min-height: 22px;
  font-weight: 600;
  white-space: nowrap;
  text-align: center;
  color: #fff;
}

.form-field {
  margin: 6px;
}

.form-field > input {
  width: 180px;
  height: 54px;
  padding: 0 16px;
  font-size: 14px;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  background-color: #f2f2f6;
}

.form-field > label {
  height: 54px;
  width: 56px;
  font-size: 14px;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  background-color: #7e8e9edf;
}

.form-submit {
  margin: 6px;
}

.button-submit {
  width: 268px;
  height: 54px;
  font-weight: 700;
  text-transform: uppercase;
  color: #eee;
  background-color: #25aae1;
  border-radius: 0.25rem;
}

.form-notice {
  box-sizing: border-box;
  width: 268px;
  padding: 5px 15px;
  margin: 5px;
  border-radius: 4px;
  font-size: 12px;
  background-color: #fffe;
  color: #444;
}

.form-notice > strong {
  font-size: 14px;
  margin-bottom: 3px;
  text-transform: uppercase;
}

.form-notice > ul {
  margin: 0;
  margin-left: 15px;
  padding: 0;
}
</style>
